import useSessions from '@/composables/useSessions'
import useBasket from '@/composables/useBasket'
import { clearTrip } from '@/composables/useTrip'
import { clearAmend } from '@/composables/useAmend'

// Signing out on purpose means leaving this device, so nothing from the account's
// purchase or amendment (basket, passenger names, booking info) is left for whoever
// uses the browser next. A lapsed session is not this: it goes through logOut alone
// and keeps the basket. Search choices stay, as they say nothing about the account.
export default function useSignOut () {
  const { logOut } = useSessions()
  const { clearLocalBasket } = useBasket()

  const clearAccountData = ({ revokeToken = true } = {}) => {
    clearLocalBasket()
    clearAmend()
    clearTrip()
    logOut(!revokeToken)
  }

  return { clearAccountData }
}
